import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../contexts/auth";
import { useNavigate, useParams } from "react-router-dom";
import { Container, Row, Col, Form, Card, Button, Navbar, Badge, Spinner } from "react-bootstrap";

import Geo_alunos_range from "./geo_alunos_range";
import Geo_lista_escolas from "./geo_lista_escolas";
import Geo_lista_populacao from "./geo_lista_populacao";
import Mapa_escolas from "./geo_mapa_escolas";

const Geo_modulo_mestre = () => {

    const perfil = JSON.parse(localStorage.getItem("perfil"));

    // Dicionário de unidades e códigos (Adicionada a opção de Expansão com código "00")
    const listaUnidades = [
        { nome: '📍 Nova Unidade (Modo Expansão)', codigo: '00' },
        { nome: 'Bento Ribeiro', codigo: '01' },
        { nome: 'Madureira', codigo: '02' },
        { nome: 'Santa Cruz', codigo: '03' },
        { nome: 'Cascadura', codigo: '04' },
        { nome: 'Taquara', codigo: '05' },
        { nome: 'Nilópolis', codigo: '06' },
        { nome: 'Nova Iguaçu', codigo: '07' },
        { nome: 'Seropédica', codigo: '09' },
        { nome: 'Barra da Tijuca', codigo: '10' },
        { nome: 'Campo Grande', codigo: '11' },
        { nome: 'Mangueira', codigo: '13' },
        { nome: 'Maricá', codigo: '14' },
        { nome: 'Ilha do Governador', codigo: '15' },
        { nome: 'Freguesia', codigo: '16' },
        { nome: 'Recreio dos Bandeirantes', codigo: '17' }
    ];

    const unidades = ['', 'Bento Ribeiro', 'Madureira', 'Santa Cruz', 'Cascadura', 'Taquara', 'Nilopolis', 'Nova Iguaçu', '', 'Seropédica', 'Barra', 'Campo Grande', 'Centro de Excelência', 'Mangueira', 'Maricá', 'Ilha', 'Freguesia', 'Recreio'];

    const usuario = JSON.parse(localStorage.getItem("user"));
    const token = localStorage.getItem("token");

    const { authenticated, logout } = useContext(AuthContext);
    const navigate = useNavigate();
    const [acesso, setAcesso] = useState(false);

    // Estados dos filtros locais
    const [unidade, setUnidade] = useState("");
    const [range, setRange] = useState(2);
    const [enderecoExpansao, setEnderecoExpansao] = useState(""); // Novo estado para o endereço
    const [loadingGeo, setLoadingGeo] = useState(false); // Estado de loading para a API de mapa

    // Estados que disparam as buscas nos filhos
    // Adicionado o 'enderecoLabel' para mostrar o nome da rua pesquisada na Navbar
    const [filtrosAtivos, setFiltrosAtivos] = useState({ unidade: "", range: "", enderecoLabel: "" });
    const [carregouPesquisa, setCarregouPesquisa] = useState(false);

    // ESTADOS GLOBAIS DE CORRELAÇÃO (Dados que os filhos vão enviar para o Mestre)
    const [totaisEscolas, setTotaisEscolas] = useState(0);
    const [totaisPopulacao, setTotaisPopulacao] = useState({ bairros: 0, totalJovem: 0 });
    const [totaisAlunos, setTotaisAlunos] = useState(0);


    const handleFiltrar = async (e) => {
        e.preventDefault();

        if (!unidade) {
            alert("Por favor, selecione uma unidade antes de buscar.");
            return;
        }

        // LÓGICA DE INTERCEPTAÇÃO: MODO EXPANSÃO
        if (unidade === "00") {
            if (!enderecoExpansao.trim()) {
                alert("Para o Modo Expansão, você precisa digitar um endereço completo.");
                return;
            }

            setLoadingGeo(true);
            try {
                // Consome a API pública do OpenStreetMap para Geocoding
                const response = await fetch(`https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(enderecoExpansao)}`);
                const data = await response.json();

                if (data && data.length > 0) {
                    const lat = data[0].lat;
                    const lon = data[0].lon;

                    // Monta a string especial para a nossa function do banco interpretar
                    const stringExpansao = `EXP:${lat},${lon}`;

                    // Reseta os contadores
                    setTotaisEscolas(0);
                    setTotaisPopulacao({ bairros: 0, totalJovem: 0 });
                    setTotaisAlunos(0);

                    setFiltrosAtivos({
                        unidade: stringExpansao,
                        range: parseFloat(range),
                        enderecoLabel: enderecoExpansao
                    });
                    setCarregouPesquisa(true);
                } else {
                    alert("Endereço não encontrado no mapa. Tente ser mais específico (Ex: Rua Conde de Bonfim, 100, Rio de Janeiro).");
                }
            } catch (error) {
                console.error("Erro ao converter endereço em coordenadas:", error);
                alert("Erro ao acessar o serviço de mapas. Tente novamente em instantes.");
            } finally {
                setLoadingGeo(false);
            }

            return; // Encerra a função aqui para o modo expansão
        }

        // LÓGICA NORMAL: UNIDADES EXISTENTES
        // Reseta os contadores antigos antes da nova busca
        setTotaisEscolas(0);
        setTotaisPopulacao({ bairros: 0, totalJovem: 0 });
        setTotaisAlunos(0);

        setFiltrosAtivos({ unidade, range: parseFloat(range), enderecoLabel: "" });
        setCarregouPesquisa(true);
    };

    if (perfil[0].perfil !== "GESTOR") {
        return (
            <div className="d-flex align-items-center justify-content-center" style={{ minHeight: "100vh", backgroundColor: "#f8f9fa" }}>
                <Card className="shadow-lg border-0" style={{ maxWidth: "500px", textAlign: "center" }}>
                    <Card.Body className="p-5">
                        <div className="mb-4">
                            <i className="fas fa-lock" style={{ fontSize: "4rem", color: "#dc3545" }}></i>
                        </div>
                        <Card.Title className="fs-3 fw-bold text-danger mb-3">Acesso Restrito</Card.Title>
                        <Card.Text className="text-secondary mb-4">
                            Desculpe, você não tem permissão para acessar esta página. Apenas gestores podem visualizar esta funcionalidade.
                        </Card.Text>
                        <Button href="/" variant="primary" size="lg" className="w-100">
                            <i className="fas fa-home me-2"></i> Voltar à Página Inicial
                        </Button>
                    </Card.Body>
                </Card>
            </div>
        )
    }

    // Helper para renderizar o selo da Navbar dependendo do modo
    const renderBadgeFiltro = () => {
        if (filtrosAtivos.unidade.startsWith("EXP:")) {
            return `📍 Expansão: ${filtrosAtivos.enderecoLabel} | Raio: ${filtrosAtivos.range}km`;
        }
        return `Filtro: Unidade ${unidades[parseInt(filtrosAtivos.unidade)]} | Raio: ${filtrosAtivos.range}km`;
    };

    return (
        <div className="bg-light" style={{ minHeight: "100vh", paddingBottom: "100px" }}>
            {/* 1. NAVBAR ÚNICA E CENTRALIZADA */}
            <Navbar sticky="top" bg="dark" variant="dark" className="px-4 shadow-sm justify-content-between">
                <Navbar.Brand className="fw-bold fs-5 text-info">
                    SANTA MÔNICA REDE DE ENSINO — GEOMARKETING
                </Navbar.Brand>
                {carregouPesquisa && (
                    <Badge bg="secondary" className="fs-6 py-2 px-3 text-truncate" style={{ maxWidth: "50%" }}>
                        {renderBadgeFiltro()}
                    </Badge>
                )}
            </Navbar>

            <Container fluid className="px-4 mt-4">
                {/* 2. PAINEL DE FILTROS */}
                <Row className="mb-4">
                    <Col xs={12}>
                        <Card className="shadow-sm border-0 border-top border-primary border-3">
                            <Card.Body className="p-4">
                                <Form onSubmit={handleFiltrar}>
                                    <Row className="align-items-end">

                                        {/* Dropdown Ajusta Tamanho Dependendo da Escolha */}
                                        <Col md={unidade === "00" ? 3 : 5} xs={12} className="mb-3 mb-md-0">
                                            <Form.Group controlId="selectUnidade">
                                                <Form.Label className="fw-bold text-muted small text-uppercase">Unidade Base ou Projeto</Form.Label>
                                                <Form.Select
                                                    value={unidade}
                                                    onChange={(e) => setUnidade(e.target.value)}
                                                    className={`form-control-lg fs-6 ${unidade === "00" ? "border-primary text-primary fw-bold" : ""}`}
                                                >
                                                    <option value="">-- Selecione a Unidade --</option>
                                                    {listaUnidades.map((u) => (
                                                        <option key={u.codigo} value={u.codigo}>
                                                            {u.nome} {u.codigo !== '00' ? `(${u.codigo})` : ''}
                                                        </option>
                                                    ))}
                                                </Form.Select>
                                            </Form.Group>
                                        </Col>

                                        {/* Input de Endereço (Só aparece se Modo Expansão "00") */}
                                        {unidade === "00" && (
                                            <Col md={5} xs={12} className="mb-3 mb-md-0">
                                                <Form.Group controlId="enderecoExpansao">
                                                    <Form.Label className="fw-bold text-primary small text-uppercase">Endereço do Novo Imóvel</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        placeholder="Ex: Rua Conde de Bonfim, 100, Rio de Janeiro"
                                                        value={enderecoExpansao}
                                                        onChange={(e) => setEnderecoExpansao(e.target.value)}
                                                        className="form-control-lg fs-6 border-primary"
                                                        required={unidade === "00"}
                                                    />
                                                </Form.Group>
                                            </Col>
                                        )}

                                        <Col md={unidade === "00" ? 2 : 5} xs={12} className="mb-3 mb-md-0">
                                            <Form.Group controlId="rangeSlider">
                                                <div className="d-flex justify-content-between align-items-center mb-2">
                                                    <Form.Label className="fw-bold text-muted small m-0 text-uppercase">Raio de Cobertura</Form.Label>
                                                    <Badge bg="primary" className="fs-6 px-2">{range} Km</Badge>
                                                </div>
                                                <Form.Range
                                                    min={1}
                                                    max={20}
                                                    step={0.5}
                                                    value={range}
                                                    onChange={(e) => setRange(e.target.value)}
                                                />
                                            </Form.Group>
                                        </Col>

                                        <Col md={2} xs={12} className="text-md-end text-center">
                                            <Button
                                                variant="primary"
                                                type="submit"
                                                size="lg"
                                                className="w-100 fw-bold shadow-sm d-flex align-items-center justify-content-center gap-2"
                                                disabled={loadingGeo}
                                            >
                                                {loadingGeo ? (
                                                    <><Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> Mapeando...</>
                                                ) : (
                                                    "🔍 ANALISAR"
                                                )}
                                            </Button>
                                        </Col>
                                    </Row>
                                </Form>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>

                {/* 3. GRIDS DE RESULTADOS EM LAYOUT DE DASHBOARD */}
                {carregouPesquisa ? (
                    <Row>
                        <Col lg={6} sm={12} className="mb-4">
                            <Card className="shadow-sm border-0">
                                <Card.Header className="bg-white border-0 py-3">
                                    <h5 className="m-0 fw-bold text-primary">🌐 0. Escolas na Região</h5>
                                </Card.Header>
                                <Card.Body className="p-0">
                                    <Mapa_escolas
                                        unidade={filtrosAtivos.unidade}
                                        range={filtrosAtivos.range}
                                    />
                                </Card.Body>
                            </Card>
                        </Col>

                        <Col lg={6} sm={12} className="mb-4">
                            <Card className="shadow-sm border-0">
                                <Card.Header className="bg-white border-0 py-3">
                                    <h5 className="m-0 fw-bold text-primary">📍 1. Escolas Mapeadas na Região</h5>
                                </Card.Header>
                                <Card.Body className="p-0">
                                    <Geo_lista_escolas
                                        unidade={filtrosAtivos.unidade}
                                        range={filtrosAtivos.range}
                                        onDataProcessed={setTotaisEscolas}
                                    />
                                </Card.Body>
                            </Card>
                        </Col>

                        <Col lg={6} sm={12} className="mb-4">
                            <Card className="shadow-sm border-0">
                                <Card.Header className="bg-white border-0 py-3">
                                    <h5 className="m-0 fw-bold text-success">👥 2. Censo Demográfico por Bairro de Alcance</h5>
                                </Card.Header>
                                <Card.Body className="p-0">
                                    <Geo_lista_populacao
                                        unidade={filtrosAtivos.unidade}
                                        range={filtrosAtivos.range}
                                        onDataProcessed={setTotaisPopulacao}
                                    />
                                </Card.Body>
                            </Card>
                        </Col>

                        <Col lg={6} sm={12} className="mb-4">
                            <Card className="shadow-sm border-0">
                                <Card.Header className="bg-white border-0 py-3">
                                    <h5 className="m-0 fw-bold text-info">🎓 3. Potencial de Mercado (Matrículas por Escola)</h5>
                                </Card.Header>
                                <Card.Body className="p-0">
                                    <Geo_alunos_range
                                        unidade={filtrosAtivos.unidade}
                                        range={filtrosAtivos.range}
                                        onDataProcessed={setTotaisAlunos}
                                    />
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                ) : (
                    <Row>
                        <Col xs={12} className="text-center py-5">
                            <div className="text-muted fs-5 py-5 bg-white rounded shadow-sm border">
                                💡 Insira os parâmetros operacionais acima para gerar o relatório consolidado de inteligência competitiva.
                            </div>
                        </Col>
                    </Row>
                )}
            </Container>

            {/* 4. RODAPÉ FIXO MESTRE UNIFICADO */}
            {carregouPesquisa && (
                <footer className="fixed-bottom bg-dark text-white p-3 shadow-lg border-top border-secondary" style={{ zIndex: 1030 }}>
                    <Container fluid className="d-flex justify-content-around align-items-center flex-wrap gap-3 font-monospace small">
                        <div>
                            🏢 ESCOLAS NA REGIÃO: <Badge bg="primary" className="fs-6">{totaisEscolas}</Badge>
                        </div>
                        <div className="border-start border-secondary ps-3">
                            🏘️ BAIRROS COBERTOS: <Badge bg="success" className="fs-6">{totaisPopulacao.bairros}</Badge>
                        </div>
                        <div className="border-start border-secondary ps-3">
                            👶 POPULAÇÃO JOVEM TOTAL (0-19): <Badge bg="warning" text="dark" className="fs-6">{totaisPopulacao.totalJovem}</Badge>
                        </div>
                        <div className="border-start border-secondary ps-3">
                            ✏️ TOTAL MATRÍCULAS CONCORRÊNCIA: <Badge bg="info" text="dark" className="fs-6">{totaisAlunos}</Badge>
                        </div>
                    </Container>
                </footer>
            )}
        </div>
    );
};

export default Geo_modulo_mestre;